import React from 'react';
import './FranchiseHero.css';

// Responsive hero images
import heroDesktop from '../../Franchise_Page_Images/1-Franchise-hero-desktop-01.png';
import heroTablet from '../../Franchise_Page_Images/1-Franchise-hero-tablet-01.png';
import heroMobile from '../../Franchise_Page_Images/1-Franchise-hero-mobile-01.png';

const FranchiseHero: React.FC = () => {
  return (
    <div className="franchise-hero">
      <div className="franchise-hero__image-container">
        <picture>
          <source media="(min-width: 1025px)" srcSet={heroDesktop} />
          <source media="(min-width: 431px)" srcSet={heroTablet} />
          <img
            src={heroMobile}
            alt="Sweetspot Cannabis Dispensary Franchise"
            className="franchise-hero__image"
          />
        </picture>
      </div>
    </div>
  );
};

export default FranchiseHero;
